module.exports = __webpack_public_path__ + "4f589f4867dbd57ebanner-3.3322b63e.png";